import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Media} from 'kpc';

var _$tmp0 = {
    'type': 'image',
    'size': 'small',
    'src': 'https://images.unsplash.com/photo-1521572267360-ee0c2909d518?auto=format&fit=crop&w=240&q=80'
};
var _$tmp1 = {
    'type': 'image',
    'src': 'https://images.unsplash.com/photo-1500534314209-a25ddb2bd429?auto=format&fit=crop&w=240&q=80'
};
var _$tmp2 = {
    'type': 'image',
    'size': 'large',
    'src': 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=320&q=80'
};
var _$tmp3 = {
    'name': '预告片.mp4',
    'type': 'video',
    'size': 'small',
    'src': 'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4'
};
var _$tmp4 = {
    'name': '预告片.mp4',
    'type': 'video',
    'src': 'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4'
};
var _$tmp5 = {
    'name': '预告片.mp4',
    'type': 'video',
    'size': 'large',
    'src': 'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4'
};
var _$tmp6 = {
    'name': '品牌播客.mp3',
    'type': 'audio',
    'size': 'small',
    'src': 'https://interactive-examples.mdn.mozilla.net/media/cc0-audio/t-rex-roar.mp3'
};
var _$tmp7 = {
    'name': '品牌播客.mp3',
    'type': 'audio',
    'src': 'https://interactive-examples.mdn.mozilla.net/media/cc0-audio/t-rex-roar.mp3'
};
var _$tmp8 = {
    'name': '品牌播客.mp3',
    'type': 'audio',
    'size': 'large',
    'src': 'https://interactive-examples.mdn.mozilla.net/media/cc0-audio/t-rex-roar.mp3'
};
var _$tmp9 = {
    'name': '横向海报.mp4',
    'type': 'video',
    'width': 120,
    'height': 72,
    'src': 'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4'
};
var _$tmp10 = {
    'name': '音频片段.mp3',
    'type': 'audio',
    'width': 72,
    'height': 96,
    'src': 'https://interactive-examples.mdn.mozilla.net/media/cc0-audio/t-rex-roar.mp3'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$ce(2, 'div', [
            _$ce(2, 'div', '图片', 16, 'media-demo-size-label'),
            _$ce(2, 'div', [
                _$cc(Media, _$tmp0),
                _$cc(Media, _$tmp1),
                _$cc(Media, _$tmp2)
            ], 4, 'media-demo-size-row')
        ], 4, 'media-demo-size-section'),
        _$ce(2, 'div', [
            _$ce(2, 'div', '视频', 16, 'media-demo-size-label'),
            _$ce(2, 'div', [
                _$cc(Media, _$tmp3),
                _$cc(Media, _$tmp4),
                _$cc(Media, _$tmp5)
            ], 4, 'media-demo-size-row')
        ], 4, 'media-demo-size-section'),
        _$ce(2, 'div', [
            _$ce(2, 'div', '音频', 16, 'media-demo-size-label'),
            _$ce(2, 'div', [
                _$cc(Media, _$tmp6),
                _$cc(Media, _$tmp7),
                _$cc(Media, _$tmp8)
            ], 4, 'media-demo-size-row')
        ], 4, 'media-demo-size-section'),
        _$ce(2, 'div', [
            _$ce(2, 'div', '自定义宽高', 16, 'media-demo-size-label'),
            _$ce(2, 'div', [
                _$cc(Media, _$tmp9),
                _$cc(Media, _$tmp10)
            ], 4, 'media-demo-size-row')
        ], 4, 'media-demo-size-section')
    ], 4, 'media-demo-size');
};